import { combineReducers } from 'redux';

import deleteSeoTranslationError from './deleteSeoTranslationError';
import deleteSeoTranslationsError from './deleteSeoTranslationsError';
import editSeoTranslationError from './editSeoTranslationError';
import deleteSeoTranslationsByLangError from './deleteSeoTranslationsByLangError';
import createCustomTagError from './createCustomTagError';
import deleteCustomTagError from './deleteCustomTagError';


export default combineReducers({
  deleteSeoTranslationError,
  deleteSeoTranslationsError,
  editSeoTranslationError,
  deleteSeoTranslationsByLangError,
  createCustomTagError,
  deleteCustomTagError,
});
